<template>
    <div class="observe">
        <div class="layout-page-box">
            <el-form :inline="true" label-width="100px" label-position="right" class="search-form">
                <el-form-item label="客户姓名">
                    <el-input v-model.trim="filters.clientName" clearable placeholder="请输入客户姓名"></el-input>
                </el-form-item>
                <el-form-item label="客户手机号">
                    <el-input v-model.trim="filters.clientMobile" clearable placeholder="请输入客户手机号"></el-input>
                </el-form-item>
                <el-form-item label="时间">
                    <el-date-picker v-model="filters.startTime" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd">
                    </el-date-picker>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="search" size="small">查询</el-button>
                </el-form-item>
            </el-form>
            <div class="buttonText">
                <el-button type="warning" @click="add" icon="el-icon-edit">新增留观</el-button>
                <!-- <el-button type="warning" @click="hand" icon="el-icon-edit"></el-button> -->
            </div>
        </div>
        <div class="layout-page-box">
            <el-table :data="tableData" style="width: 100%" @selection-change="handleSelectionChange" :height="tableHeight" :header-cell-style="{color:'#626365'}">
                <el-table-column type="selection" width="55"></el-table-column>
                <el-table-column sortable prop="id" label="编号" align="center"></el-table-column>
                <el-table-column sortable prop="clientName" label="姓名"></el-table-column>
                <el-table-column sortable prop="clientAge" label="年龄"></el-table-column>
                <el-table-column sortable prop="clientSex" label="性别"></el-table-column>
                <el-table-column sortable prop="bedNumber" label="床号"></el-table-column>
                <el-table-column sortable prop="hospitalizedTime" label="入院日期" width="100"></el-table-column>
                <!-- <el-table-column sortable prop="entranceTime" label="入观日期" width="100"></el-table-column> -->
                <el-table-column sortable prop="operationTime" label="手术时间" width="135"></el-table-column>
                <el-table-column sortable prop="createBy" label="添加人" width="120"></el-table-column>
                <el-table-column sortable prop="createTime" label="添加时间" width="90"></el-table-column>
                <el-table-column align="center" label="操作" width="160">
                    <template slot-scope="scope">
                        <el-button size="mini" style="margin-bottom:5px;" type="primary" @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
                        <el-button size="mini" style="margin-bottom:5px;" type="primary" @click="handleDetail(scope.$index, scope.row)">详情</el-button>
                        <el-popover placement="left" width="100" trigger="click">
                            <div class="pop">
                                <el-button size="mini" :disabled="scope.row.handoverRecord" style="margin-bottom:5px;" type="primary" @click="hand(scope.$index, scope.row)">新增护理交接记录</el-button>
                                <el-button size="mini" :disabled="scope.row.nursingRecords" style="margin-bottom:5px;" type="primary" @click="addAir(scope.$index, scope.row)">新增护理记录单</el-button>
                                <el-button size="mini" :disabled="scope.row.temperatureSheet" style="margin-bottom:5px;" type="primary" @click="addSheet(scope.$index, scope.row)">新增体温单</el-button>
                                <el-button size="mini" :disabled="scope.row.doctorAdviceTemporary" style="margin-bottom:5px;" type="primary" @click="order(scope.$index, scope.row)">新增临时医嘱单</el-button>
                                <el-button size="mini" :disabled="scope.row.doctorAdvicePermanently" style="margin-bottom:5px;" type="primary" @click="orderSheet(scope.$index, scope.row)">新增长期医嘱单</el-button>
                            </div>
                            <el-button slot="reference" size="mini" style="margin-left:5px;" type="warning">更多</el-button>
                        </el-popover>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination @size-change="handleSizeChange" @current-change="pageChanged" :current-page="filters.pagination.page" :page-size="filters.pagination.limit" :page-sizes="[10, 20, 30, 50]" layout="total, sizes,prev, pager, next, jumper" :total="filters.pagination.total">
            </el-pagination>
        </div>
        <!-- 新增编辑身份弹框 -->
        <el-dialog :visible.sync="dialogFormVisible" center class="dialogItem" :close-on-click-modal="false">
            <el-form :model="formList" label-width="100px">
                <!-- <el-form-item label="姓名">
                    <el-input v-model.trim="formList.empName" style="width:95%;" placeholder="请输入姓名"></el-input>
                </el-form-item> -->
                <el-form-item label="姓名">
                    <el-input v-model.trim="formList.clientName" style="width:95%;" placeholder="请输入姓名"></el-input>
                </el-form-item>
                <el-form-item label="性别">
                    <el-select v-model="formList.clientSex" clearable placeholder="请选择性别" style="width:95%;">
                        <el-option v-for="(item, index) in sexey" :key="index" :label="item.label" :value="item.label"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="年龄">
                    <el-input v-model.trim="formList.clientAge" style="width:95%;" placeholder="请输入年龄"></el-input>
                </el-form-item>
                <el-form-item label="联系方式">
                    <el-input v-model.trim="formList.clientMobile" style="width:95%;" placeholder="请输入联系方式"></el-input>
                </el-form-item>
                <el-form-item label="床号">
                    <el-input v-model.trim="formList.bedNumber" style="width:95%;" placeholder="请输入床号"></el-input>
                </el-form-item>
                <el-form-item label="入院日期">
                    <el-date-picker v-model="formList.hospitalizedTime" value-format="yyyy-MM-dd" type="date" placeholder="请选择入院日期" style="width:95%;"></el-date-picker>
                </el-form-item>
                <el-form-item label="入观时间">
                    <el-date-picker v-model="formList.entranceTime" format="yyyy-MM-dd HH:mm" value-format="yyyy-MM-dd HH:mm" type="datetime" placeholder="请选择入观时间" style="width:95%;"></el-date-picker>
                </el-form-item>
                <el-form-item label="手术时间">
                    <div v-for="(item,index) in formList.timeSlot" :key="index" class="timeKey">
                        <el-date-picker format="yyyy-MM-dd HH:mm" value-format="yyyy-MM-dd HH:mm" v-model="item.startTime" type="datetime" placeholder="请选择手术开始时间"></el-date-picker>
                        <span>至</span>
                        <el-date-picker format="yyyy-MM-dd HH:mm" value-format="yyyy-MM-dd HH:mm" v-model="item.endTime" type="datetime" placeholder="请选择手术结束时间"></el-date-picker>
                        <el-button type="danger" size="mini" @click="delTime(item,index)"><i class="el-icon-delete"></i></el-button>
                    </div>
                    <el-button style="float:right;" @click="addTime" type="primary" size="mini">添加手术时间<i class="el-icon-plus"></i></el-button>
                </el-form-item>
                <el-form-item label="出观时间">
                    <el-date-picker format="yyyy-MM-dd HH:mm" value-format="yyyy-MM-dd HH:mm" v-model="formList.exportTime" type="datetime" placeholder="请选择出观时间" style="width:95%;"></el-date-picker>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer partFooter">
                <el-button type="danger" @click="dialogFormVisible=false">取 消</el-button>
                <el-button type="primary" @click="doAddgoods()">确 定</el-button>
            </div>
        </el-dialog>
        <!-- 详情弹框 -->
        <el-dialog :visible.sync="detailDialog" center class="dialogItem" :close-on-click-modal="false">
            <detail :formDetail="formDetail" @close="close"></detail>
        </el-dialog>
    </div>
</template>
<script>
import { mapState, } from 'vuex'
import detail from './detail'
export default {
    name: 'observation',
    computed: {
        ...mapState(["sexey",]),
    },
    components: {
        detail
    },
    data() {
        return {
            filters: {
                pagination: {
                    page: 1,
                    limit: 10,
                    total: 0
                },
                startTime: '',
                endTime: '',
            },
            tableData: [],
            multipleSelection: [],
            dialogFormVisible: false,
            detailDialog: false,
            formList: {
                timeSlot: [
                    {
                        startTime: '',
                        endTime: '',
                    }
                ],
            },
            tableHeight: "",
            isId: '',
            userInfo: {},
            formDetail: {},
        }
    },
    created() {
        this.tableHeight = document.documentElement.clientHeight - 270
    },
    mounted() {
        /*this.init();*/
        this.query(this.filters.pagination.page);
    },
    watch: {
        $route(to, from) {
            if (this.$route.query.code == 0) {
                this.query(this.filters.pagination.page);
            } else {
                if (this.activatedFlag) {
                    this.query(this.filters.pagination.page);
                }
            }
        },
    },
    methods: {
        testSX() {
            this.$forceUpdate()
        },
        search() {
            this.filters.pagination.page = 1
            this.refresh()
        },
        handleSelectionChange(val) {
            this.multipleSelection = val;
        },
        pageChanged(page) {
            this.filters.pagination.page = page
            this.refresh()
        },
        handleSizeChange(sizes) {
            this.filters.pagination.limit = sizes
            this.refresh()
        },
        refresh() {
            router.push({
                path: this.$route.path,
                query: _.merge({}, this.$route.query, {
                    __query: JSON.stringify(this.pagination)
                }, {
                        random: Math.random()
                    })
            })
        },
        addTime() {
            this.formList.timeSlot.push({
                startTime: '',
                endTime: '',
                key: Date.now()
            })
            this.$forceUpdate()
        },
        delTime(item, listIndex) {
            // console.log(val);
            var index = this.formList.timeSlot.indexOf(item)
            if (index !== -1) {
                this.formList.timeSlot.splice(listIndex, 1)
            }
            this.$forceUpdate()
        },
        // 新增项目
        add() {
            this.dialogFormVisible = true
            this.isId = ''
            // 新增置空
            this.formList = {
                timeSlot: [
                    {
                        startTime: '',
                        endTime: '',
                    }
                ],
            }
        },

        handleEdit(index, row) {
            console.log(row);
            this.isId = row.id
            this.dialogFormVisible = true
            this.getDetail(row)
        },
        close() {
            this.detailDialog = false
        },
        handleDetail(index, row) {
            this.detailDialog = true
            let querys = {
                id: row.id,
                detailsView: true,
            }
            api.request('/leaveObserve/findLeaveObserveInfoById', querys, (res) => {
                this.formDetail = res.data
                // console.log(this.formDetail);
                // this.formList.timeSlot = this.formList.operationTime
            })
        },
        getDetail(row) {
            let querys = {
                id: row.id,
            }
            api.request('/leaveObserve/findLeaveObserveInfoById', querys, (res) => {
                this.formList = res.data
                // this.formList.timeSlot = this.formList.operationTime
            })
        },
        doAddgoods() {
            this.formList.createBy = Lockr.get('skinEmpId')
            console.log(this.formList);
            if (this.isId) {
                api.requestQuiet("/leaveObserve/updateLeaveObserveInfo", this.formList, (res) => {
                    if (res.result == true) {
                        this.dialogFormVisible = false
                        _g.toast("success", '修改成功');
                        this.query(this.filters.pagination.page)
                    } else {
                        _g.toast("error", res.errMsg);
                    }
                }, (err) => { });
            } else if (!this.isId) {
                api.requestQuiet("/leaveObserve/createLeaveObserveInfo", this.formList, (res) => {
                    if (res.result == true) {
                        this.dialogFormVisible = false
                        _g.toast("success", '添加成功');
                        this.query(this.filters.pagination.page)
                    } else {
                        _g.toast("error", res.errMsg);
                    }
                }, (err) => { });
            }

        },
        // 查询数据列表
        query(page) {
            // console.log(this.filters.startTime)
            var querys = {
                // project: this.filters.project,
                // projectCategory: this.filters.projectCategory,
                startTime: '',
                endTime: '',
                page: page,
                size: this.filters.pagination.limit,
                clientName: this.filters.clientName,
                clientMobile: this.filters.clientMobile,
            }
            if (this.filters.startTime) {
                querys.startTime = this.filters.startTime[0]
                querys.endTime = this.filters.startTime[1]
            }
            // console.log(querys)
            api.request('/leaveObserve/findLeaveObserveInfoByPage', querys, (res) => {
                // console.log(res)
                var data = res.data.list
                this.tableData = data
                this.filters.pagination.total = parseInt(res.data.count)
            })
        },
        // 新增交接记录
        hand(index, row) {
            // if (Object.keys(this.userInfo).length === 0) {
            //     _g.toast('warning', '请选择用户信息！！！')
            //     return
            // } else {
            //     this.userInfo.code = 0
            //     router.push({ name: 'hand', params: row })
            // }
            row.code = 0
            router.push({ name: 'hand', params: row })
            console.log(row);
        },
        // currentChange(currentRow) {
        //     this.userInfo = currentRow
        // },
        // 新增护理记录
        addAir(index, row) {
            row.code = 0
            router.push({ name: 'nursingRecord', params: row })
        },
        // 新增体温表
        addSheet(index, row) {
            row.code = 0
            api.request('/leaveObserve/findTemperatureSheet', { id: row.id }, (res) => {
                row.tem = res.data
                if (res.result == true) {
                    router.push({ name: 'temperature', params: row })
                }
            })
        },
        // 新增临时医嘱单
        order(index, row) {
            row.code = 0
            router.push({ name: 'sheetForm', params: row })
        },
        //新增长期医嘱单
        orderSheet(index, row) {
            row.code = 0
            router.push({ name: 'orderSheet', params: row })
        },
    },


}
</script>
<style scoped>
@import "../../assets/css/main.css";
.flex {
  display: flex;
  align-items: flex-start;
}
.flex >>> .el-button i {
  margin: 0 !important;
}
.flex >>> .el-button--mini {
  margin: 8px;
}
.timeKey {
  /* border: 1px solid red; */
  margin-bottom: 10px;
}
.timeKey >>> .el-button i {
  margin: 0 !important;
}
.pop >>> .el-button + .el-button,
.el-checkbox.is-bordered + .el-checkbox.is-bordered {
  margin-left: 0px !important;
}
.observe >>> .el-form-item__content {
  line-height: 32px !important;
}
</style>